<!-- begin breadcrumb -->
<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item active">Asegurados</li>
</ol>
<!-- end breadcrumb -->
<!-- begin page-header -->
<h1 class="page-header"><i class="fas fa-users"></i> Asegurados:
</h1>
<!-- end page-header -->


@if(!insuredModel && !newInsured){
<div class="card border-0 shadow-sm mb-4">
    <div class="card-body">
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div class="col-lg-6 px-0">
                <div class="row g-2">
                    <div class="col-sm-3 col-12">
                        <ng-select [items]="searchByFilter" [clearable]="false" [(ngModel)]="searchBy"
                            name="searchBy"></ng-select>
                    </div>
                    <div class="col-sm col-12">
                        <label for="search-input" class="visually-hidden">Buscar asegurado</label>
                        <input type="text" class="form-control" [(ngModel)]="rut" id="search-input"
                            placeholder="Ingrese su búsqueda" (keyup.enter)="searchInsured()">
                    </div>
                    <div class="col-sm-auto col-12">
                        <button class="btn btn-primary px-3 w-100" (click)="searchInsured()"><i class="fas fa-search"></i> Buscar</button>
                    </div>
                </div>
            </div>
        </div>
        @if(searched){
        <div class="table-responsive d-flex justify-content-center mt-4">
            <table class="table table-sm table-hover table-striped">
                <thead>
                    <tr>
                        <th>N°</th>
                        <th>Nombre</th>
                        <th>RUT</th>
                        <th>Correo</th>
                        <th><i class="fas fa-cog"></i></th>
                    </tr>
                </thead>
                <tbody>
                    @for(insured of insuredList; track insured._id; let index = $index){
                    <tr>
                        <td>{{ index + 1 }}</td>
                        <td>{{ insured.names }} {{ insured.surname }} {{ insured.lastname }}</td>
                        <td>{{ insured.rut | numberPipe }}-{{ insured.dv}}</td>
                        <td>{{ insured.mail }}</td>
                        <td>
                            <button class="btn btn-xs btn-primary" (click)="setInsured(insured)"> <i
                                    class="fas fa-edit"></i></button>
                        </td>
                    </tr>
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="4" class="text-center">No encontraste a la persona que buscabas, Aqui puedes
                            incorporarla</td>
                        <td>
                            <button class="btn btn-success btn-xs" (click)="setNewInsured()"> <i
                                    class="fas fa-user-plus"></i></button>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
        }
    </div>
</div>


}@else if(!newInsured){

<div class="mb-3 d-md-flex fw-bold">
    <div class="mt-md-0 mt-2">
        <a role="button" tabindex="0" class="text-decoration-none text-dark" (click)="insuredModel = null" (keydown.enter)="insuredModel = null" aria-label="Volver a la búsqueda"> <i
                class="fa fa-arrow-left fa-fw me-1 text-dark text-opacity-50"></i> Volver </a>
    </div>
</div>


<div class="row gx-4">
    <div class="col-xl-8 col-lg-12">
        <div class="card shadow-sm border-0 mb-4">
            <app-personal-information [insured]="insuredModel" [editData]="false"
                [permissions]="permissions?.personal_information" (update)="updateInsured($event)"></app-personal-information>
        </div>
    </div>
    <div class="col-xl-4 col-lg-12">
        <div class="card shadow-sm border-0 mb-4">
            <app-bank-account-view [insuredId]="insuredModel._id"></app-bank-account-view>
        </div>

    </div>
</div>
<div class="row gx-4">
    <div class="col-xl-12 col-lg-12">
        <div class="card shadow-sm border-0 mb-4">
            <app-contracted-policies [insured]="insuredModel"
                (updatePolicySelected)="policySelected($event)"></app-contracted-policies>
        </div>
    </div>
    <div class="col-xl-12 col-lg-12">
        @if(insuredModel && policySel){
        <div class="card shadow-sm border-0 mb-4">
            <app-additionals [insured]="insuredModel" [policy]="policySel" [editData]="false"
                (change)="changeInsured($event)" [permissions]="permissions?.group_family"></app-additionals>
        </div>
        }
    </div>
</div>
}

@if(newInsured){
<app-incorporation (cancel)="newInsured = false"></app-incorporation>
}